import React from 'react';
import PropTypes from 'prop-types';

import CloseButton from './CloseButton/CloseButton.styled';
import { StyledNotification } from './Notification.styled';

const Notification = ({ item, clickClose }) => {
  const { data, style } = item;

  let message;
  if (typeof data === 'string') {
    message = <div>{data}</div>;
  }
  else if (data?.response?.body) {
    message = (
      <>
        {!data.response.body.message ? null : (
          <div>{data.response.body.message}</div>
        )}
        {!data.response.body.errorData ? null : (
          <div>
            {Object.keys(data.response.body.errorData).map((key, index) => (
              <div key={index}>
                <strong>{key}:</strong> {data.response.body.errorData[key]}
              </div>
            ))}
          </div>
        )}
      </>
    )
  }

  return (
    <StyledNotification $style={style}>
      {message || ''}

      <CloseButton
        $style={style}
        href="#"
        onClick={e => {
          e.preventDefault();
          clickClose();
        }}
      />
    </StyledNotification>
  );
};

Notification.propTypes = {
  item: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  clickClose: PropTypes.func
};

export default Notification;
